/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import {notification} from 'antd';
import CustomIcon from './components/CustomIcon/CustomIcon';

/**
 * To show the notification messages to the user
 */
class Notification {

  icon = (type) => {
    switch(type) {
      case 'success':
        return <CustomIcon name="Check" color="#FFFFFF" />
      case 'info':
        return <CustomIcon name="Info" color="#FFFFFF" />
      case 'warning':
        return <CustomIcon name="ErrorAlert" color="#FFFFFF" />
      case 'error':
        return <CustomIcon name="ErrorAlert" color="#FFFFFF" />
      default:
        return <CustomIcon name="Info" color="#FFFFFF" />  
    }
  }

  /**
   * Method to display a notification popup whenever user performs an action
   */
  show = (type, title, description) => {
    notification[type]({
      message: title,
      duration: this.duration,
      placement: this.placement,
      description: description,
      icon: this.icon(type),
      closeIcon: <CustomIcon name="CloseX" color="#FFFFFF" /> 
    });
  };

  constructor(duration = 3, placement = 'bottom') {
    this.duration = duration;
    this.placement = placement;
  };
};

export default Notification;